module.exports = __webpack_public_path__ + "img/GA.4fc2e56b.svg";